module.exports = __webpack_public_path__ + "img/logo-la-cite.94f84a34.svg";